(function() {
  var container = document.querySelector('.ai-pack-selector');
  if (!container) return;
  var cards = container.querySelectorAll('.ai-pack-card');

  cards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      if (card.classList.contains('unavailable')) {
        e.preventDefault();
        return;
      }

      // Immediate visual feedback
      cards.forEach(function(c) { c.classList.remove('active'); });
      card.classList.add('active');

      var variantId = card.dataset.variantId;

      // Update the hidden variant input
      var variantInput = document.querySelector('input[name="id"]');
      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update URL immediately
      var url = new URL(window.location);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);

      // Fire multiple events immediately to catch all listeners (theme + Appstle)
      var events = ['change', 'variant:change', 'variantChange'];
      events.forEach(function(eventName) {
        document.dispatchEvent(new CustomEvent(eventName, {
          detail: { 
            variantId: parseInt(variantId), 
            variant: { 
              id: parseInt(variantId),
              name: document.querySelector('.ai-pack-card.active .ai-pack-card-label')?.textContent || ''
            } 
          },
          bubbles: true
        }));
      });

      // Also trigger on the form directly
      var form = document.querySelector('form[action="/cart/add"]');
      if (form) {
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
})();
// Subscribe & Save price toggle
(function() {
  const DISCOUNT = 0.30;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updatePackPrices(isSubscription) {
    document.querySelectorAll('.ai-pack-card').forEach(function(card) {
      const priceEl = card.querySelector('.ai-pack-card-price');
      if (!priceEl) return;

      const msrp = parseInt(card.dataset.msrp, 10);
      if (!msrp) return;

      if (isSubscription) {
        const discounted = Math.round(msrp * (1 - DISCOUNT));
        priceEl.innerHTML = `
          <span style="text-decoration:line-through;opacity:0.5;font-weight:400;">${formatMoney(msrp)}</span>
          <span style="margin-left:6px;">${formatMoney(discounted)}</span>
        `;
      } else {
        priceEl.innerHTML = formatMoney(msrp);
      }
    });
  }

  function bindSellingPlanListeners() {
    document.querySelectorAll('input[name="selling_plan"]').forEach(function(input) {
      input.addEventListener('change', function() {
        updatePackPrices(this.value !== '');
      });
    });
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', function() {
    bindSellingPlanListeners();
  });

  // Re-bind if Appstle re-renders (it sometimes does)
  const observer = new MutationObserver(function() {
    bindSellingPlanListeners();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
